import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <SimpleTable>
    <div>
      <div>Beep:</div>
      <div>{node.extras.playBeep ? 'Yes' : 'No'}</div>
    </div>
    <div>
      <div>Transcribe</div>
      <div>{node.extras.transcribe ? 'Yes' : 'No'}</div>
    </div>
    <div>
      <div>Finish Key:</div>
      <div>{node.extras.finishOnKey}</div>
    </div>
  </SimpleTable>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Record/RecordDisplay.jsx